export const SortAscending = (props: any) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.74919 6.28845L5.23357 6.28845L5.23357 16.64C5.23357 16.726 5.30388 16.7963 5.38982 16.7963L6.48357 16.7963C6.56951 16.7963 6.63982 16.726 6.63982 16.64L6.63982 6.28845L8.12419 6.28845C8.25505 6.28845 8.32927 6.13611 8.24724 6.03455L6.05974 3.26306C6.04512 3.24439 6.02645 3.22928 6.00513 3.2189C5.98381 3.20851 5.96041 3.20311 5.93669 3.20311C5.91298 3.20311 5.88958 3.20851 5.86826 3.2189C5.84694 3.22928 5.82826 3.24439 5.81365 3.26306L3.62615 6.03455C3.54607 6.13611 3.61833 6.28845 3.74919 6.28845Z"
        fill="currentColor"
      />
      <rect x="8.75" y="14" width="7.91667" height="1.33333" rx="0.2" fill="currentColor" />
      <rect x="10.4166" y="11" width="6.25" height="1.33333" rx="0.2" fill="currentColor" />
      <rect x="11.25" y="8" width="5.41667" height="1.33333" rx="0.2" fill="currentColor" />
      <rect x="12.0834" y="5" width="4.58333" height="1.33333" rx="0.2" fill="currentColor" />
    </svg>
  );
};
